import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import lang from '@/lang'

const DatevExportContentTooltip = (props) => {
  const classes = useStyles()
  const { data: { content = [] } = {} } = props

  const contentItems = content.map((type) => {
    const label = lang.documentExport.content[type]

    return label ? <span key={type}>{label}</span> : null
  })

  return (
    <div className={classes.container}>
      {contentItems}
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: 'fit-content',
    border: theme.border,
    borderRadius: theme.borderRadius,
    boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
    backgroundColor: theme.white,
    overflow: 'hidden',
    '& span': {
      margin: 2,
      whiteSpace: 'nowrap',
    },
  },
}))

DatevExportContentTooltip.propTypes = {
  data: PropTypes.object.isRequired,
}

export default DatevExportContentTooltip
